import React from "react";
import loadImage from "blueimp-load-image";
import Select from "react-select";
import _ from "lodash";

import "./TokenWalletModal.css";

class TokenWalletModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      pot1: "",
      pot2: "",
      pot1Name: "",
      pot2Name: "",
      ecoCoin: "",
      liveCoin: ""
    };
  }

  componentDidMount() {
    const { initialValue } = this.props;
    if (initialValue) {
      this.setState({
        ...(initialValue || {
          pot1: "",
          pot2: "",
          pot1Name: "",
          pot2Name: "",
          ecoCoin: "",
          liveCoin: ""
        })
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { initialValue } = this.props;
    if (initialValue !== prevProps.initialValue) {
      this.setState({
        ...(initialValue || {
          pot1: "",
          pot2: "",
          pot1Name: "",
          pot2Name: "",
          ecoCoin: "",
          liveCoin: ""
        })
      });
    }
  }

  onChangeHandler = e => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSave = event => {
    event.stopPropagation();
    const { onSave } = this.props;
    const { pot1, pot1Name, pot2, pot2Name, liveCoin, ecoCoin } = this.state;

    onSave({ pot1, pot2, pot1Name, pot2Name, liveCoin, ecoCoin });
  };

  render() {
    const { pot1, pot2, pot1Name, pot2Name, liveCoin, ecoCoin } = this.state;
    const { id } = this.props;

    return (
      <div
        className="modal fade token-wallet-modal"
        id={`token-wallet-modal-${id}`}
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Edit Token Wallet</h5>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body pb-1">
              <div
                style={{
                  marginBottom: 10
                }}
              >
                <p className="section-title">Live coin</p>
                <div className="input-group">
                  <input
                    type="number"
                    name="liveCoin"
                    className="form-control form-control-md form-control-alt"
                    placeholder="Live coin"
                    onChange={this.onChangeHandler}
                    value={liveCoin}
                  />
                  <div className="suffix">%</div>
                </div>
                <p className="section-title">Eco coin</p>
                <div className="input-group">
                  <input
                    type="number"
                    name="ecoCoin"
                    className="form-control form-control-md form-control-alt"
                    placeholder="Eco coin"
                    onChange={this.onChangeHandler}
                    value={ecoCoin}
                  />
                  <div className="suffix">%</div>
                </div>
                <p className="section-title">Pot 1</p>
                <div className="input-group">
                  <input
                    type="number"
                    name="pot1"
                    className="form-control form-control-md form-control-alt"
                    placeholder="Pot 1"
                    onChange={this.onChangeHandler}
                    value={pot1}
                  />
                  <div className="suffix">%</div>
                </div>
                <p className="section-title">Pot 1 Name</p>
                <input
                  name="pot1Name"
                  className="form-control form-control-md form-control-alt"
                  placeholder="Pot 1 Name"
                  onChange={this.onChangeHandler}
                  value={pot1Name}
                />
                <p className="section-title">Pot 2</p>
                <div className="input-group">
                  <input
                    type="number"
                    name="pot2"
                    className="form-control form-control-md form-control-alt"
                    placeholder="Pot 2"
                    onChange={this.onChangeHandler}
                    value={pot2}
                  />
                  <div className="suffix">%</div>
                </div>
                <p className="section-title">Pot 2 Name</p>
                <input
                  name="pot2Name"
                  className="form-control form-control-md form-control-alt"
                  placeholder="Pot 2 Name"
                  onChange={this.onChangeHandler}
                  value={pot2Name}
                />
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-sm btn-light"
                data-dismiss="modal"
              >
                Close
              </button>
              <button
                type="button"
                className="btn btn-sm btn-success"
                data-dismiss="modal"
                onClick={this.onSave}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default TokenWalletModal;



// WEBPACK FOOTER //
// ./src/components/TokenWalletModal/TokenWalletModal.js